'use client';

import type { CSSProperties, ElementType } from 'react';
import { type SxProps, Typography } from '@mui/material';
import { useComputedColor } from '@/hooks/useComputedColor';

export function Text(props: {
	text: string | undefined | null;
	className?: string;
	sx?: SxProps;
	style?: CSSProperties;
	typographyComponent?: string;
	disableColorDetection?: boolean;
}) {
	const computedColor = useComputedColor();

	return (
		<Typography
			className={props.className}
			sx={props.sx}
			style={{
				color: props.disableColorDetection ? undefined : computedColor,
				...props.style,
			}}
			// Fallback to div to avoid cases like nested <p> tags
			component={(props.typographyComponent as ElementType) ?? 'div'}
			dangerouslySetInnerHTML={{ __html: props.text ?? '' }}
		/>
	);
}
